import { Selector, State } from "./types";
import { wbsConfiguration } from "@planzone/dto";

function createSelector(getState: () => State): Selector {
  return {
    isRetrieveWbsConfigurationRequestFailure({ uuid }) {
      const req = getState().find(({ planzone }) => planzone.uuid === uuid);

      return req ? req.request.isFailure : false;
    },
    isRetrieveWbsConfigurationRequestPending({ uuid }) {
      const req = getState().find(({ planzone }) => planzone.uuid === uuid);

      return req ? req.request.isPending : false;
    },
    isRetrieveWbsConfigurationRequestSuccess({ uuid }) {
      const req = getState().find(({ planzone }) => planzone.uuid === uuid);

      return req ? req.request.isSuccessful : false;
    },
    getWbsConfiguration({ uuid }) {
      const req = getState().find(({ planzone }) => planzone.uuid === uuid);

      return req ? req.configuration : wbsConfiguration;
    },
  };
}

export { createSelector };
